import React from 'react';
import { navigate } from 'gatsby';
import WebsiteImage from 'components/WebsiteImage';
import RichText from 'components/RichText';
import Icon from 'components/Icon';
import { truncateText } from 'utils/text';

import { NavigationItemContainer } from './styles';

const NavigationItem = ({ excerpt, hoverText, link, icon }) => {
  const hoverRawText = hoverText?.raw && JSON.parse(hoverText?.raw).content[0]?.content[0]?.value;

  return (
    <NavigationItemContainer onClick={() => link && navigate(link)} hasLink={link}>
      <div className="default">
        <WebsiteImage {...icon} />
        <RichText content={excerpt} />
        {link && <Icon id="black-right-arrow" className="blue-arrow" />}
      </div>
      {hoverRawText && (
        <div className="hoverText">
          <p>{truncateText(hoverRawText, 75)}</p>
          {link && <Icon id="blue-right-arrow" className="blue-arrow" />}
        </div>
      )}
    </NavigationItemContainer>
  );
};

export default NavigationItem;
